import styled from "styled-components";

export default styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 250px;
    width: 100%;
    background: rgba(118, 184, 82, 0.7); /* fallback for old browsers */
    
    
    color:#fff;
    margin: 0 15px;
    font-size: 4em;
    @media only screen and (max-width: 600px){
        font-size: 1em;
    }
    /* cursor: pointer; */
    
`;